var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_vm._v("Caricamento in corso... "),_c('img',{attrs:{"src":_vm.getLoaderImage(),"width":"60","height":"60"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }